import React, {useState, useEffect} from 'react'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {DataStep1} from './SettingsModel'
import * as Yup from 'yup'
import axios from 'axios'
import Swal from 'sweetalert2'
import {useNavigate} from 'react-router-dom'
import {initialQueryState, KTIcon, useDebounce} from '../../../../_metronic/helpers'
import '../../index.css'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import Switch from '@mui/material/Switch'
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'
import Checkbox from '@mui/material/Checkbox'
const profileDetailsSchema = Yup.object().shape({
  fName: Yup.string().required('First name is required'),
  lName: Yup.string().required('Last name is required'),
  code: Yup.string().required('code is required'),
  contactPhone: Yup.string().required('Contact phone is required'),
})

const Step3 = (props: any) => {
  const API_URL = process.env.REACT_APP_API_URL
  const PVL_URL2 = process.env.REACT_APP_PVL_URLV2
  const navigate = useNavigate()
  const [typeList, setTypeList] = useState<any>([{name: 'auto'}, {name: 'upload'}])
  const [type, setType] = useState<any>({name: 'auto'})

  const AlertError = (message: string) => {
    Swal.fire('', message, 'error')
  }

  const [amount, setAmount] = useState<any>(0)
  const [length, setLength] = useState<any>(0)
  const [symbols, setSymbols] = useState<any>(false)
  const [uppercase, setUppercase] = useState<any>(false)
  const [numbers, setNumbers] = useState<any>(false)
  const [lowercase, setLowercase] = useState<any>(false)

  const create3 = async () => {
    let temp: any = []
    console.log({
      deal_id: props.dataID,
      config_length: Number(length),
      amount: Number(amount),
      config_symbols: symbols,
      config_uppercase: uppercase,
      config_numbers: numbers,
      config_lowercase: lowercase,
    })
    Swal.fire({
      title: '',
      text: 'Confirm Create',
      icon: 'info',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
      showLoaderOnConfirm: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        const data = await axios.post(`${PVL_URL2}/deal-code/generate`, {
          deal_id: props.dataID,
          config_length: Number(length),
          amount: Number(amount),
          config_symbols: symbols,
          config_uppercase: uppercase,
          config_numbers: numbers,
          config_lowercase: lowercase,
        }).then(async (res) => {
          await Swal.fire('Success', 'Success', 'success')
          props.click(3)

        })
        .catch((err) => {
          Swal.fire('Create !', 'Your can not Create. !! ' + err, 'error')
        })
      }
    })
    
  }

  useEffect(
    () => {},
    [] // Only re-call effect if value or delay changes
  )

  const uploadExcel = async (e: any) => {
    if (e.target.files.length) {
      e.preventDefault()
      var _URL = window.URL || window.webkitURL
      var file = e.target.files[0]
      var formdata = new FormData()
      formdata.append('image', file)
      var requestOptions = {
        method: 'POST',
        body: formdata,
        redirect: 'follow',
      }
      const data = await axios.post(`${API_URL}/upload`, formdata)
    }
  }

  const [loading, setLoading] = useState(false)

  return (
    <div className='card mb-5 mb-xl-10'>
      <div id='kt_account_profile_details' className='collapse show'>
        <div className='form'>
          <div className='card-body border-top p-9'>
            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>Type</label>
              <div className='col-lg-6 fv-row'>
                <Autocomplete
                  //multiple
                  id='tags-standard'
                  options={typeList}
                  getOptionLabel={(option: any) => option.name}
                  defaultValue={typeList[0]}
                  onChange={(event: any, newValue: any | null) => {
                    console.log(newValue)
                    if (newValue != null) {
                      setType(newValue)
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant='standard'
                      //label='Multiple values'
                      //placeholder='Favorites'
                    />
                  )}
                />
              </div>
            </div>

            {type.name == 'auto' && (
              <>
                <h1 className='mb-6'>Auto Generate</h1>
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label fw-bold fs-6'>ความยาว</label>
                  <div className='col-lg-6 fv-row'>
                    <input
                      //disabled={true}
                      onChange={(e)=>{
                        setLength(e.target.value)
                      }}
                      type='text'
                      className='form-control form-control-lg form-control-solid'
                      placeholder=''
                    />
                  </div>
                </div>
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label fw-bold fs-6'>จำนวน</label>
                  <div className='col-lg-6 fv-row'>
                    <input
                      //disabled={true}
                      onChange={(e)=>{
                        setAmount(e.target.value)
                      }}
                      type='text'
                      className='form-control form-control-lg form-control-solid'
                      placeholder=''
                    />
                  </div>
                </div>
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label fw-bold fs-6'></label>
                  <div className='col-lg-6 fv-row'>
                    <Checkbox defaultChecked={uppercase} onChange={(e)=>{
                      setUppercase(e.target.checked)
                    }}/>
                    <span>ตัวพิมพ์ใหญ่</span>
                  </div>
                </div>
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label fw-bold fs-6'></label>
                  <div className='col-lg-6 fv-row'>
                    <Checkbox defaultChecked={lowercase} onChange={(e)=>{
                      setUppercase(e.target.checked)
                    }}/>
                    <span>ตัวพิมพ์เล็ก</span>
                  </div>
                </div>
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label fw-bold fs-6'></label>
                  <div className='col-lg-6 fv-row'>
                    <Checkbox defaultChecked={numbers} onChange={(e)=>{
                      setUppercase(e.target.checked)
                    }}/>
                    <span>ตัวเลข</span>
                  </div>
                </div>
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label fw-bold fs-6'></label>
                  <div className='col-lg-6 fv-row'>
                    <Checkbox defaultChecked={symbols} onChange={(e)=>{
                      setUppercase(e.target.checked)
                    }}/>
                    <span>สัญลักษณ์</span>
                  </div>
                </div>
              </>
            )}
            {type.name == 'upload' && (
              <>
                <h1 className='mb-6'>Upload Code</h1>
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label fw-bold fs-6'>
                    <span>Excel</span>
                  </label>

                  <div className='col-lg-6 fv-row'>
                    <input
                      disabled={true}
                      type='tel'
                      className='form-control form-control-lg form-control-solid'
                      placeholder=''
                    />
                  </div>
                  <div className='col-lg-2 fv-row'>
                    <span className='btn btn-primary btn-file wbt editbtn'>
                      {!loading && 'Add File'}
                      {loading && (
                        <span className='indicator-progress' style={{display: 'block'}}>
                          Please wait...{' '}
                          <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                        </span>
                      )}
                      <input disabled={loading} type='file' accept='.xlsx' onChange={uploadExcel} />
                    </span>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      
        <div className='card-footer d-flex justify-content-end py-6 px-9'>
          <button
            //type='submit'
            className='btn btn-primary marginSet'
            disabled={loading}
            onClick={() => {
              //props.handleChild(2)
              //setStep(Number(step) + 1)
              props.clickback(3)
              console.log('press')
            }}
          >
            {!loading && 'Back'}
            {loading && (
              <span className='indicator-progress' style={{display: 'block'}}>
                Please wait...{' '}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
          {type.name == 'auto' && (<button
            type='submit'
            className='btn btn-primary'
            disabled={loading}
            onClick={async() => {
              console.log('press')
              await create3()
            }}
          >
            {!loading && 'Finish'}
            {loading && (
              <span className='indicator-progress' style={{display: 'block'}}>
                Please wait...{' '}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>)}
        </div>
      
    </div>
  )
}

export {Step3}
